function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState } from 'react';
import TextField from "./textfield/TextField";
import { form_validator } from './FormFieldValidator';
import TextFieldMultiValue from "./textfield/TextFieldMultiValue";
import Textarea from "./textarea/Textarea";
import CheckboxCollection from "../checkbox/CheckboxCollectionContext";
import RichTextfield from "../text/rte/RichTextfield";
import RadioGroup from "../radio-group/RadioGroup";
import Dropdown from "./dropdown/Dropdown";
import DatePicker from "../date/picker/DatePicker";
import LocationSearch from "../maps/LocationSearch";
import YesOrNo from "../yes-or-no/YesOrNo";
import TextfieldCollection from "./textfield-collection/TextfieldCollection";
import TimePicker from "noood/comp/time/time-picker/TimePicker";
import HiddenField from "noood/comp/form/textfield/HiddenField";
import TogglePill from "noood/comp/button/TogglePill";
import NumberPlusMinus from "noood/comp/number-plus-minus/NumberPlusMinus";
import PickDate from "noood/comp/date/picker/PickDate";
import OptionPicker from "noood/comp/form/dropdown/OptionPicker";
import { FormContext } from 'noood/contexts/contexts';
import PickTime from "noood/comp/date/picker/PickTime";
import PasswordHelper from "noood/comp/form/PasswordHelper";
export var FormFieldCollectorContext = /*#__PURE__*/React.createContext(null);
/**
 * @typedef {Object} FormContextShape
 * @property {Object} formObj
 * @property {function} __collect
 */

export default function Form(props) {
  var _useState = useState(props.obj),
    _useState2 = _slicedToArray(_useState, 2),
    formObj = _useState2[0],
    setFormObj = _useState2[1];
  var _useState3 = useState({}),
    _useState4 = _slicedToArray(_useState3, 2),
    fieldErrors = _useState4[0],
    setFieldErrors = _useState4[1];
  var _useState5 = useState({}),
    _useState6 = _slicedToArray(_useState5, 2),
    validationErrors = _useState6[0],
    setValidationErrors = _useState6[1];
  var _useState7 = useState(undefined),
    _useState8 = _slicedToArray(_useState7, 2),
    errorMessage = _useState8[0],
    setErrorMessage = _useState8[1];
  var _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    is_processing = _useState0[0],
    __is_processing = _useState0[1];
  var _useState1 = useState(false),
    _useState10 = _slicedToArray(_useState1, 2),
    is_static = _useState10[0],
    set_is_static = _useState10[1];
  var _useState11 = useState(),
    _useState12 = _slicedToArray(_useState11, 2),
    propObjString = _useState12[0],
    setPropObjString = _useState12[1];
  useEffect(function () {
    if (propObjString !== void 0) {
      var _props$__collect, _props$__setter, _Object$keys, _props$__validSetter;
      var initFormObj = {};
      var init_errors = {};
      _probe(props.children, initFormObj, init_errors, 0);
      setFormObj(initFormObj);
      setFieldErrors(init_errors);
      var finalObj = initFormObj;
      if (props.appendableFragmentKey && props.appendableFragment) {
        var _finalObj = _objectSpread(_objectSpread({}, initFormObj), {}, _defineProperty({}, props.appendableFragmentKey, props.appendableFragment));
      }
      (_props$__collect = props.__collect) === null || _props$__collect === void 0 || _props$__collect.call(props, finalObj, init_errors);
      (_props$__setter = props.__setter) === null || _props$__setter === void 0 || _props$__setter.call(props, finalObj);
      // total errors
      var totalErrors = (_Object$keys = Object.keys(init_errors)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.reduce(function (total, key) {
        var thisItemErrorCount = init_errors[key].length;
        return total + thisItemErrorCount;
      }, 0);
      (_props$__validSetter = props.__validSetter) === null || _props$__validSetter === void 0 || _props$__validSetter.call(props, totalErrors === 0);
    }
  }, [propObjString]);
  useEffect(function () {
    var _props$obj;
    setPropObjString(JSON.stringify((_props$obj = props.obj) !== null && _props$obj !== void 0 ? _props$obj : {}));
  }, [props.obj]);
  useEffect(function () {
    set_is_static(props.is_static);
  }, [props.is_static]);
  useEffect(function () {
    setValidationErrors(props.validationErrors);
  }, [props.validationErrors]);
  var _probe = function __probe(children, form, errors, depth) {
    // console.log(`depth:`, depth);
    var childrenn = children;
    if (!Array.isArray(children)) {
      childrenn = [children];
    }
    childrenn.forEach(function (child, idx) {
      var _child$type, _child$type2;
      if (child !== null && child !== void 0 && (_child$type = child.type) !== null && _child$type !== void 0 && _child$type.displayName || child !== null && child !== void 0 && (_child$type2 = child.type) !== null && _child$type2 !== void 0 && _child$type2.name) {
        var _child$type$displayNa;
        var type_name = (_child$type$displayNa = child.type.displayName) !== null && _child$type$displayNa !== void 0 ? _child$type$displayNa : child.type.name;
        if (type_name === TextField.displayName || type_name === TextFieldMultiValue.name || type_name === Textarea.name || type_name === CheckboxCollection.name || type_name === RichTextfield.name || type_name === RadioGroup.name || type_name === Dropdown.name || type_name === DatePicker.name || type_name === LocationSearch.name || type_name === YesOrNo.displayName || type_name === TextfieldCollection.name || type_name === TimePicker.name || type_name === HiddenField.name || type_name === TogglePill.displayName || type_name === NumberPlusMinus.name || type_name === PickDate.displayName || type_name === OptionPicker.displayName || type_name === PickTime.displayName || type_name === PasswordHelper.displayName) {
          var _props$obj2;
          var val = props.obj ? (_props$obj2 = props.obj) === null || _props$obj2 === void 0 ? void 0 : _props$obj2[child.props.name] : child.props.value;
          form[child.props.name] = val;
          var validation_errors = form_validator.validate(child.props.validations, val);
          errors[child.props.name] = validation_errors;
        }
      }
      if (child !== null && child !== void 0 && child.type) {
        var _child$props;
        if ((_child$props = child.props) !== null && _child$props !== void 0 && _child$props.children) {
          _probe(child.props.children, form, errors, ++depth);
        } else {
          // the fields are inside this function? probe this function
        }
      }
    });
  };
  function __submit(event) {
    var _props$__submit;
    event.preventDefault();
    var finalObj = {};
    var finalErrors = {};
    _probe(props.children, finalObj, finalErrors, 0);
    (_props$__submit = props.__submit) === null || _props$__submit === void 0 || _props$__submit.call(props, finalObj, fieldErrors, function (response) {
      if (response !== null && response !== void 0 && response.field_errors) {
        var _props$__validSetter2;
        setValidationErrors(response.field_errors);
        (_props$__validSetter2 = props.__validSetter) === null || _props$__validSetter2 === void 0 || _props$__validSetter2.call(props, false);
      } else {
        setValidationErrors(undefined);
      }
    });
  }
  function field_value_collector(value, field, errors) {
    var _props$__collect2, _Object$keys2, _props$__validSetter3;
    var updated_form = _objectSpread({}, formObj);
    updated_form[field] = value;
    setFormObj(updated_form);
    var updated_errors = _objectSpread({}, fieldErrors);
    updated_errors[field] = errors;
    setFieldErrors(updated_errors);
    (_props$__collect2 = props.__collect) === null || _props$__collect2 === void 0 || _props$__collect2.call(props, updated_form, updated_errors);
    if (props.appendableFragmentKey && props.appendableFragment) {
      var _props$__setter2;
      (_props$__setter2 = props.__setter) === null || _props$__setter2 === void 0 || _props$__setter2.call(props, _objectSpread(_objectSpread({}, updated_form), {}, _defineProperty({}, props.appendableFragmentKey, props.appendableFragment)));
    } else {
      var _props$__setter3;
      (_props$__setter3 = props.__setter) === null || _props$__setter3 === void 0 || _props$__setter3.call(props, updated_form);
    }
    if (props.__collect === void 0 && props.__validate) {
      props.__validate(updated_errors);
    }
    // total errors
    var totalErrors = (_Object$keys2 = Object.keys(updated_errors)) === null || _Object$keys2 === void 0 ? void 0 : _Object$keys2.reduce(function (total, key) {
      var thisItemErrorCount = updated_errors[key].length;
      return total + thisItemErrorCount;
    }, 0);
    (_props$__validSetter3 = props.__validSetter) === null || _props$__validSetter3 === void 0 || _props$__validSetter3.call(props, totalErrors <= 0);
    setValidationErrors(undefined);
  }

  /**
   * @param {string} field
   * @param {*} value
   * @param errors
   * @private
   */
  var __collect = function __collect(field, value, errors) {
    console.log("collecting: field=".concat(field, ", value=").concat(value));
    field_value_collector(value, field, errors);
  };
  var __merge = function __merge(partial_obj) {
    var _props$__collect3, _props$__setter4;
    var merged = _objectSpread(_objectSpread({}, formObj), partial_obj);
    setFormObj(merged);
    (_props$__collect3 = props.__collect) === null || _props$__collect3 === void 0 || _props$__collect3.call(props, merged, {});
    (_props$__setter4 = props.__setter) === null || _props$__setter4 === void 0 || _props$__setter4.call(props, merged);
  };
  var __delete = function __delete(property) {
    var form_copy = _objectSpread({}, formObj);
    delete form_copy[property];
    setFormObj(form_copy);
  };

  /*useEffect(() => {
    let initFormObj = {};
    let init_errors = {};
    __probe(props.children, initFormObj, init_errors, 0);
    // console.log(`initFormObj: `, initFormObj);
    setFormObj(initFormObj)
    setFieldErrors(init_errors)
    props.__validate?.(init_errors);
    props.__validSetter?.(no_errors(init_errors));
  }, [props.obj]);*/

  var __registerErrors = function __registerErrors(field, errors) {
    try {
      var _props$__validate;
      var newFieldErrors = fieldErrors ? _objectSpread({}, fieldErrors) : {};
      if (newFieldErrors[field]) {
        var newErrors = (errors === null || errors === void 0 ? void 0 : errors.length) > 0 ? errors : [];
        newFieldErrors[field] = [].concat(_toConsumableArray(newFieldErrors[field]), _toConsumableArray(newErrors));
      }
      setFieldErrors(newFieldErrors);
      setValidationErrors(newFieldErrors);
      (_props$__validate = props.__validate) === null || _props$__validate === void 0 || _props$__validate.call(props, newFieldErrors);
    } catch (e) {
      // console.log(e)
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: 'text-negative'
  }, errorMessage), /*#__PURE__*/React.createElement(FormContext.Provider, {
    value: {
      formObj: formObj,
      __validSetter: props.__validSetter,
      field_value_collector: field_value_collector,
      __collect: __collect,
      __merge: __merge,
      __delete: __delete,
      __registerErrors: __registerErrors,
      fieldErrors: fieldErrors,
      is_static: is_static,
      validationErrors: validationErrors,
      setValidationErrors: setValidationErrors,
      setFieldErrors: setFieldErrors
    }
  }, /*#__PURE__*/React.createElement(FormFieldCollectorContext.Provider, {
    value: field_value_collector
  }, /*#__PURE__*/React.createElement("form", {
    onSubmit: function onSubmit(e) {
      __submit(e);
    },
    autoComplete: 'off'
  }, props.children))));
}

/*
Form.propTypes = {
  __collect: PropTypes.func,
  __submit: PropTypes.func,
  __validate: PropTypes.func,
  is_static: PropTypes.bool,
  obj: PropTypes.object,
  name: PropTypes.string,
  /!* this is the setter function *!/
  __setter: PropTypes.func
  , validationErrors: PropTypes.object
  // should this form have initial value, but the obj is only the child names only
  , initObj: PropTypes.object
  , _virtualSubmit: PropTypes.func
  , __validSetter: PropTypes.func
};*/